module.exports = __webpack_public_path__ + "img/project.e0722afd.png";